/* Zaltify V3.7: Klaviyo native product cards only. No cart DOM manipulation. */
(function(){
'use strict';
var root=document.getElementById('zv3-root');if(!root)return;
var locale=({dk:'da',fr:'fr',it:'it',es:'es',nl:'nl',de:'de',fi:'fi',eu:'en'})[location.hostname.split('.')[0]]||'en';
var translations={
da:['Se mine Zaltify-ordrer','Fortsæt samtalen','‹ Tilbage til start'],
fr:['Voir mes commandes Zaltify','Reprendre la conversation','‹ Retour au début'],
it:['I miei ordini Zaltify','Riprendi la conversazione','‹ Torna all’inizio'],
es:['Ver mis pedidos de Zaltify','Continuar conversación','‹ Volver al inicio'],
nl:['Mijn Zaltify-bestellingen','Gesprek hervatten','‹ Terug naar start'],
de:['Meine Zaltify-Bestellungen ansehen','Gespräch fortsetzen','‹ Zurück zum Start'],
fi:['Näytä Zaltify-tilaukseni','Jatka keskustelua','‹ Takaisin alkuun'],
en:['View my Zaltify orders','Continue conversation','‹ Back to start']};
var words=translations[locale]||translations.en,seen='zaltify_chat_opened';
var account=root.querySelector('#zv36-my-orders');if(account){var label=account.querySelector('span');if(label)label.textContent=words[0];account.setAttribute('aria-label',words[0]);}
var continuation=root.querySelector('#zv36-continue');
function remember(){try{sessionStorage.setItem(seen,'1')}catch(err){}}
function showContinue(){
 if(!continuation)return;
 try{continuation.hidden=sessionStorage.getItem(seen)!=='1'}catch(err){continuation.hidden=true}
}
if(continuation){continuation.textContent=words[1];continuation.addEventListener('click',function(){
 var api=window.customerHubApi;if(!api||typeof api.open!=='function')return;
 var close=root.querySelector('#zv3-close');if(close)close.click();
 api.open('/chat');remember();showContinue();
});}
root.addEventListener('click',function(event){
 var node=event.target&&event.target.closest&&event.target.closest('[data-intent],.zv35-chip,#zv3-send');
 if(node){remember();showContinue();}
},true);
showContinue();
function installBack(){
 var chat=document.querySelector('.kl-hub-route-chat');if(!chat)return;
 var head=chat.querySelector('.kl-hub-drawer__header');if(!head||head.querySelector('.zv36-home-btn'))return;
 var back=document.createElement('button');back.type='button';back.className='zv36-home-btn';
 back.textContent=words[2];back.addEventListener('click',function(){
  var api=window.customerHubApi;if(api&&typeof api.close==='function')api.close();
  var launcher=root.querySelector('#zv3-launch');
  if(launcher)setTimeout(function(){launcher.click();showContinue()},120);
 });
 head.insertBefore(back,head.firstChild);
}
var n=0;
var poll=setInterval(function(){
 var el=document.querySelector('.kl-hub-route-chat');
 if(el){var b=el.getBoundingClientRect();if(b.width>80&&b.height>80){remember();showContinue();}installBack();}
 if(++n>=1800)clearInterval(poll);
},800);
})();